import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterTipoAccidenteModel } from 'src/app/models/interfaces/tipo-accidente/IFilterTipoAccidenteModel';
import { ITipoAccidenteModel } from 'src/app/models/interfaces/tipo-accidente/ITipoAccidenteModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoAccidenteService {

  private configUrl = [environment.apiGatewayUrl, 'tipos-accidente'].join('/');
  constructor(private http: HttpClient) { }

  getListFiltered(
    model: IFilterTipoAccidenteModel
    ) : Observable<SearchResultModel<ITipoAccidenteModel[]>> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    queryParams.push(`idEstado=${model.idEstado}`);
    
    if (model.nombre !== '') {
      queryParams.push(`nombre=${model.nombre}`);
    }

    return this.http.get<SearchResultModel<ITipoAccidenteModel[]>>(
      `${this.configUrl}/filtrar?${queryParams.join('&')}`
    );
  }

  getAllList(
    model: IFilterTipoAccidenteModel
    ) : Observable<ITipoAccidenteModel[]> {
    let queryParams: string[] = new Array<string>();

    // queryParams.push(`page=${model.page}`);
    // queryParams.push(`take=${model.pageSize}`);

    return this.http.get<ITipoAccidenteModel[]>(
      `${this.configUrl}/all?${queryParams.join('&')}`
    );
  }

  getById(id: number): Observable<ITipoAccidenteModel> {
    return this.http.get<ITipoAccidenteModel>(`${this.configUrl}/${id}`);
  }

  submit(model: ITipoAccidenteModel) {
    return this.http.post<ITipoAccidenteModel>(`${this.configUrl}`, model);
  }

  update(model: ITipoAccidenteModel) {
    return this.http.put<ITipoAccidenteModel>(
      `${this.configUrl}/${model.idTipoAccidente}`,
      model
    );
  }

  delete(id: number) {
    return this.http.delete<ITipoAccidenteModel>(`${this.configUrl}/${id}`);
  }
}
